import {
  REQUEST_APPRAISER,
  RECEIVE_APPRAISER,
  ERROR_APPRAISER,
  REQUEST_APPRAISER_UPDATE,
  RECEIVE_APPRAISER_UPDATE,
  ERROR_APPRAISER_UPDATE,
  REQUEST_APPRAISERLIST,
  RECEIVE_APPRAISERLIST,
  ERROR_APPRAISERLIST,
  REQUEST_APPRAISER_MANAGERS,
  RECEIVE_APPRAISER_MANAGERS,
  ERROR_APPRAISER_MANAGERS,
  REQUEST_APPRAISER_CERTIFICATE,
  RECEIVE_APPRAISER_CERTIFICATE,
  ERROR_APPRAISER_CERTIFICATE,
  REQUEST_APPRAISER_DESIGNATION,
  RECEIVE_APPRAISER_DESIGNATION,
  ERROR_APPRAISER_DESIGNATION,
  REQUEST_APPRAISER_STATE,
  RECEIVE_APPRAISER_STATE,
  ERROR_APPRAISER_STATE,
  REQUEST_PAY_SUMMARY,
  RECEIVE_PAY_SUMMARY,
  ERROR_PAY_SUMMARY,
  REQUEST_APPRAISER_COUNTIES,
  RECEIVE_APPRAISER_COUNTIES,
  ERROR_APPRAISER_COUNTIES,
  REQUEST_MULTIPLE_APPRAISER_COUNTIES,
  RECEIVE_MULTIPLE_APPRAISER_COUNTIES,
  ERROR_MULTIPLE_APPRAISER_COUNTIES,
  REQUEST_APPRAISER_EXCLUSION_SEARCH_RESULTS,
  RECEIVE_APPRAISER_EXCLUSION_SEARCH_RESULTS,
  ERROR_APPRAISER_EXCLUSION_SEARCH_RESULTS,
  REQUEST_MINIMAL_APPRAISER_LIST,
  RECEIVE_MINIMAL_APPRAISER_LIST,
  ERROR_MINIMAL_APPRAISER_LIST,
  REQUEST_VALUATION_COORDINATORS,
  RECEIVE_VALUATION_COORDINATORS,
  ERROR_VALUATION_COORDINATORS,
  REQUEST_VALUATION_DIRECTORS,
  RECEIVE_VALUATION_DIRECTORS,
  ERROR_VALUATION_DIRECTORS,
  CLEAR_APPRAISER_PROFILE,
} from 'typeConstants';
import { appraiser as initialState } from '../initialState.tsx';

const appraiser = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_APPRAISERLIST:
      return {
        ...state,
        fetchingAppraiserList: true
      };
    case RECEIVE_APPRAISERLIST:
      return {
        ...state,
        appraiserList: action.payload,
        fetchingAppraiserList: false
      };
    case ERROR_APPRAISERLIST:
      return {
        ...state,
        fetchingAppraiserList: false
      };
    case REQUEST_APPRAISER_CERTIFICATE:
      return {
        ...state,
        fetchingCertificateList: true,
      };
    case RECEIVE_APPRAISER_CERTIFICATE:
      return {
        ...state,
        certificateList: action.payload,
        fetchingCertificateList: false,
      };
    case ERROR_APPRAISER_CERTIFICATE:
      return {
        ...state,
        fetchingCertificateList: false,
      };
    case REQUEST_APPRAISER_DESIGNATION:
      return {
        ...state,
        fetchingDesignationList: true,
      };
    case RECEIVE_APPRAISER_DESIGNATION:
      return {
        ...state,
        designationList: action.payload,
        fetchingDesignationList: false,
      };
    case ERROR_APPRAISER_DESIGNATION:
      return {
        ...state,
        fetchingDesignationList: false,
      };
    case REQUEST_APPRAISER_STATE:
      return {
        ...state,
        fetchingStateList: true
      };
    case RECEIVE_APPRAISER_STATE:
      return {
        ...state,
        stateList: action.payload,
        fetchingStateList: false
      };
    case ERROR_APPRAISER_STATE:
      return {
        ...state,
        fetchingStateList: false
      };
    case REQUEST_APPRAISER_MANAGERS:
      return {
        ...state,
        fetchingAppraiserManagers: true
      };
    case RECEIVE_APPRAISER_MANAGERS:
      /*
      The appraiserManagers are formatted into an object per getAppraiserManagers in src/actions/appraiser/index.js
      But someone went and added ANOTHER getAppraiserManagers in src/requests/appraiser/index.js that also uses the same state property,
        but dumps in an array rather than the object structure.

      Using duck typing below to figure out if it's an array coming in and format it accordingly to an object for state
       */
    {
      const newAppraiserManagers = Array.isArray(action.payload) ?
          {items: action.payload, fetched: true, type: "OPTIONS"} :
          action.payload;
      return {
        ...state,
        appraiserManagers: newAppraiserManagers,
        fetchingAppraiserManagers: false
      };
    }
    case ERROR_APPRAISER_MANAGERS:
      return {
        ...state,
        fetchingAppraiserManagers: false
      };
    case REQUEST_VALUATION_COORDINATORS:
      return {
        ...state,
        fetchingValuationCoordinators: true
      };
    case RECEIVE_VALUATION_COORDINATORS:
      return {
        ...state,
        valuationCoordinators: action.payload,
        fetchingValuationCoordinators: false
      };
    case ERROR_VALUATION_COORDINATORS:
      return {
        ...state,
        fetchingValuationCoordinators: false
      };
    case REQUEST_VALUATION_DIRECTORS:
      return {
        ...state,
        fetchingValuationDirectors: true
      };
    case RECEIVE_VALUATION_DIRECTORS:
      return {
        ...state,
        valuationDirectors: action.payload,
        fetchingValuationDirectors: false
      };
    case ERROR_VALUATION_DIRECTORS:
      return {
        ...state,
        fetchingValuationDirectors: false
      };
    case REQUEST_APPRAISER:
      return {
        ...state,
        fetchingAppraiserProfile: true
      };
    case RECEIVE_APPRAISER:
      return {
        ...state,
        appraiserProfile: action.payload,
        fetchingAppraiserProfile: false
      };
    case REQUEST_APPRAISER_UPDATE:
      return {
        ...state,
        fetchingAppraiserProfile: true
      };
    case RECEIVE_APPRAISER_UPDATE:
      return {
        ...state,
        appraiserProfile: action.payload,
        fetchingAppraiserProfile: false,
        appraiserList: {},
        fetchingAppraiserList: false
      };
    case ERROR_APPRAISER_UPDATE:
      return {
        ...state,
        appraiserProfile: action.payload,
        fetchingAppraiserProfile: false
      };
    case REQUEST_PAY_SUMMARY:
      return {
        ...state,
        fetchingPayPeriodSummary: true
      };
    case RECEIVE_PAY_SUMMARY:
      return {
        ...state,
        payPeriodSummary: action.payload,
        fetchingPayPeriodSummary: false
      };
    case ERROR_PAY_SUMMARY:
      return {
        ...state,
        fetchingPayPeriodSummary: false
      };
    case REQUEST_APPRAISER_COUNTIES:
      return {
        ...state,
        counties: null,
        fetchingCounties: true
      };
    case RECEIVE_APPRAISER_COUNTIES:
      return {
        ...state,
        counties: action.payload,
        fetchingCounties: false
      };
    case ERROR_APPRAISER_COUNTIES:
      return {
        ...state,
        counties: null,
        fetchingCounties: false
      };
    case ERROR_APPRAISER:
      return {
        ...state,
        fetchingAppraiserProfile: false,
        appraiserId: 0
      };
    case REQUEST_MULTIPLE_APPRAISER_COUNTIES:
      return {
        ...state,
        fetchingAppraiserCountiesList: true
      };
    case RECEIVE_MULTIPLE_APPRAISER_COUNTIES:
      return {
        ...state,
        fetchingAppraiserCountiesList: false,
        appraiserCountiesList: action.payload
      };
    case ERROR_MULTIPLE_APPRAISER_COUNTIES:
      return {
        ...state,
        fetchingAppraiserCountiesList: false,
      };
    case REQUEST_APPRAISER_EXCLUSION_SEARCH_RESULTS:
      return {
        ...state,
        fetchingExclusionSearchResults: true,
      };
    case RECEIVE_APPRAISER_EXCLUSION_SEARCH_RESULTS:
      return {
        ...state,
        fetchingExclusionSearchResults: false,
        exclusionSearchResults: action.payload,
      };
    case ERROR_APPRAISER_EXCLUSION_SEARCH_RESULTS:
      return {
        ...state,
        fetchingExclusionSearchResults: false,
      };
    case REQUEST_MINIMAL_APPRAISER_LIST:
      return {
        ...state,
        fetchingMinimalAppraiserList: true,
      };
    case RECEIVE_MINIMAL_APPRAISER_LIST:
      return {
        ...state,
        minimalAppraiserList: action.payload,
        fetchingMinimalAppraiserList: false,
      };
    case ERROR_MINIMAL_APPRAISER_LIST:
      return {
        ...state,
        fetchingMinimalAppraiserList: false,
      };
    case CLEAR_APPRAISER_PROFILE:
      return {
        ...state,
        appraiserProfile: {},
        fetchingAppraiserProfile: true,
      };
    default:
      return state;
  }
};

export default appraiser;
